import React from "react";
import { Card, CardHeader, CardBody, Collapse, Container } from "reactstrap";
import AuthHeader from "components/Headers/AuthHeader.js";

function Privacy() {
  React.useEffect(() => {
    document.title = "Privacy Policy";
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <AuthHeader title="Privacy Policy" lead="" deviceType={false} />
      <Container className="p-2 mt--8">
        <Card className="card-plain">
          <CardBody>
            Effective Date: May 2025 <br />
            Thank you for using Bite Logr! Your privacy is important to us. This
            Privacy Policy explains how we collect, use, and protect your
            information.
            <h2 className="mt-4">1. Information We Collect</h2>
            We collect only the data necessary to provide and improve our
            services. This may include:
            <ul>
              <li>Account information (e.g., name, email) when you sign up</li>
              <li>Data you voluntarily upload or input into the app</li>
            </ul>{" "}
            We do not collect any unnecessary personal data.
            <h2 className="mt-4">2. How We Use Your Information</h2>
            We use your data solely to:
            <ul>
              <li>Provide the services offered by the app</li>
              <li>Maintain and improve our platform</li>
              <li>Respond to customer support requests</li>
            </ul>
            <h2 className="mt-4">3. No Selling of Data</h2> We do not sell,
            trade, rent, or share your personal data with third parties for
            marketing or any other purposes.{" "}
            <h2 className="mt-4">4. Data Security</h2> We take the protection of
            your information seriously and use reasonable administrative,
            technical, and physical safeguards to protect it.
            <h2 className="mt-4">5. Data Retention</h2>
            We retain your data only as long as necessary to provide our
            services. You may request deletion of your data at any time by
            contacting us.
            <h2 className="mt-4">6. Your Rights</h2>
            You have the right to:
            <ul>
              <li>Access the information we store about you</li>
              <li>Request corrections or deletion of your data</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <h2 className="mt-4">7. Changes to This Policy</h2>
            We may update this policy from time to time. When we do, we will
            notify users via the app or by email.
            <h2 className="mt-4">8. Contact Us</h2> If you have any questions or
            concerns about this Privacy Policy, please contact us at:
            support@bitelogr.app
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default Privacy;
